import {gql} from '@apollo/client';

export const UPDATE_BASKET_STORE_CODE = gql`
  mutation updateBasketStoreCode($zipCode: String!, $subDistrict: String!) {
    updateBasketStoreCode(zipCode: $zipCode, subDistrict: $subDistrict) {
      status
      message
    }
  }
`;
